import React, { ChangeEvent, ChangeEventHandler, MouseEventHandler, ReactNode, useEffect, useLayoutEffect, useRef, useState, MouseEvent } from 'react';
import MaskedInput from "react-maskedinput";
import CurrencyInput from "react-currency-format";
import { CoreValidatorFunction } from './CoreValidations';
import { JsxElement } from 'typescript';
import { AlertIcon } from '../assets/icons/icon-alert';
import { CSSProperties } from 'react';

interface CoreInputProps {
    label?: string;
    readOnly?: boolean;
    name?: string;
    checked?: boolean;
    isDirty?: boolean;
    beforeValue?: (value: boolean) => boolean;
    onChange?: (event?: CoreEventChange) => void;
    afterValue?: (value: boolean) => boolean;
    group?: string;

}


export const CoreCheckBox = (props: CoreInputProps) => {

    // current ref
    const elementRef = useRef<HTMLDivElement>();

    let checked = props.checked;

    if (props.beforeValue) {
        let beforeValue = props.beforeValue(checked);
        checked = beforeValue;
    }


    // const onChange = (event: ChangeEvent<HTMLInputElement>) => {

    //     event.preventDefault();
    //     event.stopPropagation();

    //     const name = props.name || "";
    //     let checked = event.target.checked;
    //     console.log("onChange", name, checked);

    //     onValueChange({ name, checked });
    // }

    const onValueChange = (e: MouseEvent<HTMLDivElement>) => {
        e.stopPropagation();

        // dipatch on change to parent
        props.onChange && props.onChange({ name: props.name, checked: !checked });

    };

    let stylePolyline: CSSProperties = {
        fill: "none",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: "32px"
    };

    let styleRect: CSSProperties = {
        fill: "none",
        strokeLinejoin: "round",
        strokeWidth: "32px"
    }
    return (
        <div className="flex flex-column my-2 relative" ref={elementRef} onClick={onValueChange}>
            {props.label && <label className="px-2 text-sm m-0 text-gray-500" htmlFor={props.name}>{props.label}</label>}
            <svg width="18" height="18" viewBox="0 0 512 512">
                {checked &&
                    <polyline points="352 176 217.6 336 160 272" className='stroke-green-700' style={stylePolyline} />
                }
                <rect x="64" y="64" width="384" height="384" rx="48" ry="48" className={`${checked ? "stroke-green-700" : "stroke-gray-600"}`} style={styleRect} />
            </svg>

        </div>
    )

}